export default __webpack_public_path__ + "static/media/loader.accdb9f3.svg";